import { createFileRoute, Outlet } from "@tanstack/react-router";

import { requireSection } from "@/shared/auth/access";

/** Growth: promo codes, and what is sent to many people. One guard for all. */
export const Route = createFileRoute("/_app/growth")({
  beforeLoad: ({ context }) => {
    requireSection(context.role, "growth");
  },
  component: Outlet,
});
